import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let Cascade = class Cascade extends Vue {
  constructor() {
    super(...arguments);
    this.options = [{
      value: "浙江省",
      label: "浙江省",
      children: [{
        value: "杭州市",
        label: "杭州市",
        children: [{
          value: "临平区",
          label: "临平区"
        }, {
          value: "萧山区",
          label: "萧山区"
        }]
      }, {
        value: "金华市",
        label: "金华市",
        children: [{
          value: "义乌市",
          label: "义乌市"
        }]
      }]
    }, {
      value: "江西省",
      label: "江西省",
      children: [{
        value: "南昌市",
        label: "南昌市",
        children: [{
          value: "东湖区",
          label: "东湖区"
        }]
      }]
    }, {
      value: "河南省",
      label: "河南省",
      children: [{
        value: "平顶山市",
        label: "平顶山市",
        children: [{
          value: "卫东区",
          label: "卫东区"
        }]
      }]
    }];
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    this.zItem = value;
  }
};
__decorate([Prop({
  type: Number,
  default: 0
})], Cascade.prototype, "zIndex", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], Cascade.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], Cascade.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], Cascade.prototype, "dataChage", null);
Cascade = __decorate([Component({
  name: "cascade"
})], Cascade);
export default Cascade;